import React from 'react';
import { useTranslation } from 'react-i18next';
// 1. Importando a imagem do logo
import logo from '../assets/logoh.png';

const Navbar = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <nav className="bg-primary bg-opacity-80 backdrop-blur-md fixed w-full top-0 z-50">
      <div className="container mx-auto px-6 py-3 flex justify-between items-center">
        {/* 2. Usando o logo importado */}
        <a href="#hero">
          <img src={logo} alt="AironCore Logo" className="h-10" /> {/* Ajuste a altura 'h-10' conforme necessário */}
        </a>
        
        <div className="hidden md:flex items-center space-x-6">
          <a href="#solutions" className="text-gray-300 hover:text-accent">{t('nav_solutions')}</a>
          <a href="#threats" className="text-gray-300 hover:text-accent">{t('nav_why')}</a>
          <a href="#contact" className="bg-accent hover:bg-highlight text-white font-bold py-2 px-4 rounded">{t('nav_contact')}</a>
        </div>
        <div className="flex items-center space-x-2">
            <button onClick={() => changeLanguage('en')} className={`px-2 py-1 text-sm rounded ${i18n.language === 'en' ? 'bg-accent text-primary' : 'bg-secondary'}`}>EN</button>
            <button onClick={() => changeLanguage('pt')} className={`px-2 py-1 text-sm rounded ${i18n.language === 'pt' ? 'bg-accent text-primary' : 'bg-secondary'}`}>PT</button>
            <button onClick={() => changeLanguage('es')} className={`px-2 py-1 text-sm rounded ${i18n.language === 'es' ? 'bg-accent text-primary' : 'bg-secondary'}`}>ES</button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;